import { render } from "./MarketplacePage.vue?vue&type=template&id=792b8c5e"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__